import { render, staticRenderFns } from "./VariantItem.vue?vue&type=template&id=ca6e4a8c&scoped=true&lang=pug&"
import script from "./VariantItem.vue?vue&type=script&lang=js&"
export * from "./VariantItem.vue?vue&type=script&lang=js&"
import style0 from "./VariantItem.vue?vue&type=style&index=0&id=ca6e4a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6e4a8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout,VSpacer})
